import { render, staticRenderFns } from "./KSggzTable.vue?vue&type=template&id=46c63568&scoped=true"
import script from "./KSggzTable.vue?vue&type=script&lang=js"
export * from "./KSggzTable.vue?vue&type=script&lang=js"
import style0 from "./KSggzTable.vue?vue&type=style&index=0&id=46c63568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c63568",
  null
  
)

export default component.exports